import React from 'react';
import { ImportantMessagesQuery } from 'app/graphql/__generated__/types/contento';
import { useQuery } from 'urql';
import ImportantMessages from './ImportantMessages';
import ImportantMessageFallback from './ImportantMessageFallback';
import query from './ImportantMessages.graphql';

const ImportantMessagesContainer = () => {
    const [result] = useQuery<ImportantMessagesQuery>({
        query,
        requestPolicy: 'cache-and-network',
    });

    if (!result?.data) {
        return null;
    }

    const { data, error } = result;

    if (error) {
        return <ImportantMessageFallback />;
    }

    return <ImportantMessages messages={data.importantMessages} />;
};

export default ImportantMessagesContainer;
